<template>
  <div :class="['new-guide']">
    <img :src="dataSource[currentGuideStep].src" />
    <div @click="next" class="btn">
      {{ dataSource[currentGuideStep].btnName }}
    </div>
  </div>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue';
import './Guide.scss';

const emit = defineEmits(['changeGuideStep']);
defineProps({
  currentGuideStep: Number,
  stepLen: Number,
  dataSource: Object,
});
function next() {
  emit('changeGuideStep');
}
</script>
